"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpEmptyReportImage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_i18next_1 = require("react-i18next");
var DpEmptyReportImage_styled_1 = require("./DpEmptyReportImage.styled");
var glass_svg_1 = __importDefault(require("../../../assets/images/glass.svg"));
var image_1 = __importDefault(require("next/image"));
var DpEmptyReportImage = function (_a) {
    var primaryText = _a.primaryText, secondaryText = _a.secondaryText;
    var t = (0, react_i18next_1.useTranslation)('common').t;
    var primary = primaryText || t('emptyReports.primaryText');
    var secondary = secondaryText || t('emptyReports.secondaryText');
    return ((0, jsx_runtime_1.jsx)(DpEmptyReportImage_styled_1.StyledDpIllustration, { children: (0, jsx_runtime_1.jsxs)("div", { className: "illustration-no-items", children: [(0, jsx_runtime_1.jsx)(image_1.default, { alt: "", role: "presentation", src: glass_svg_1.default, width: 140, height: 142 }), (0, jsx_runtime_1.jsx)("h2", { className: "h3", children: primary }), (0, jsx_runtime_1.jsx)("div", { children: secondary })] }) }));
};
exports.DpEmptyReportImage = DpEmptyReportImage;
exports.default = exports.DpEmptyReportImage;
